module.exports = __webpack_public_path__ + "img/2right-dc2939f4.png";